<div class="overlay-inner-wrapper">
  <header class="header-2 scroll-x">
    <div class="branding">
      <span class="title">
        @if (openView() == 'home') {
          {{ 'Wartungsverwaltung' | mrTranslate }}
        } @else {
          {{ 'Wartungs' + openView() | mrTranslate }}
        }
      </span>
    </div>
    <div class="header-actions">
      <div class="clr-form-horizontal d-f clr-align-items-center">
        @if (objekte(); as objekte) {
          <clr-select-container class="nym margin-6-r">
            <label style="width: auto; padding: 0 2px">
              @if (objekte[otypid()]?.symbol; as symbol) {
                <cds-icon size="24" class="fill-black" [shape]="'objekttyp' + symbol" />
              }
            </label>
            <select
              clrSelect
              name="objekt"
              class="cur-color"
              [(ngModel)]="otypid"
              [ngModelOptions]="{ standalone: true }">
              @for (typ of objekte | keyvalue; track typ.key) {
                <option [ngValue]="+typ.key">{{ typ.value.bezeichnung }}</option>
              }
            </select>
          </clr-select-container>
        } @else {
          <clr-spinner class="margin-6-r" [clrSmall]="true" />
        }
      </div>
      <div class="header-nav">
        @if (openView() == 'home') {
          <a class="nav-link nav-icon close" (click)="close()">
            <cds-icon shape="times" size="22" [title]="'Schliessen' | mrTranslate" />
          </a>
        } @else {
          <a class="nav-link nav-icon" (click)="openView.set('home')">
            <cds-icon shape="view-cards" size="22" [title]="'Zurück' | mrTranslate" />
          </a>
        }
      </div>
    </div>
  </header>
  @switch (openView()) {
    @case ('home') {
      <div class="w-100-p padding-10-lr padding-12-b scroll-y h-60">
        <div class="grid" id="cards-container">
          <a (click)="openView.set('baum')" class="card clickable subgrid subgrid-rows-only">
            <div class="card-header">{{ 'Wartungsbaum' | mrTranslate }}</div>
            <div class="card-block clr-row nxm clr-align-items-center">
              <cds-icon size="36" shape="tree-view" />
              <p class="card-text clr-col-lg clr-col-md-12 clr-col-sm">
                {{
                  'Bearbeiten, Erstellen und Löschen von Wartungsarten und -arbeiten, sowie deren Verknüpfungen'
                    | mrTranslate
                }}
              </p>
            </div>
            <div class="card-footer">
              <button class="btn btn-sm btn-link">{{ 'Öffnen' | mrTranslate }}</button>
            </div>
          </a>
          <a (click)="openView.set('personal')" class="card clickable subgrid subgrid-rows-only">
            <div class="card-header">{{ 'Personal' | mrTranslate }}</div>
            <div class="card-block clr-row nxm clr-align-items-center">
              <cds-icon size="36" shape="assign-user" />
              <p class="card-text clr-col-lg clr-col-md-12 clr-col-sm">
                {{ 'Bearbeiten, Erstellen und Löschen von Personal für Wartungstätigkeiten' | mrTranslate }}
              </p>
            </div>
            <div class="card-footer">
              <button class="btn btn-sm btn-link">{{ 'Öffnen' | mrTranslate }}</button>
            </div>
          </a>
          <a (click)="openView.set('masken')" class="card clickable subgrid subgrid-rows-only">
            <div class="card-header">
              {{ 'Wartungsmasken' | mrTranslate }}
            </div>
            <div class="card-block clr-row nxm clr-align-items-center">
              <cds-icon size="36" shape="nvme" />
              <p class="card-text clr-col-lg clr-col-md-12 clr-col-sm">
                {{
                  'Bearbeiten, Erstellen und Löschen von benannten Masken mit Wartungsarten-Checkliste' | mrTranslate
                }}
              </p>
            </div>
            <div class="card-footer">
              <button class="btn btn-sm btn-link">{{ 'Öffnen' | mrTranslate }}</button>
            </div>
          </a>
          <a (click)="openView.set('zuordnung')" class="card clickable subgrid subgrid-rows-only">
            <div class="card-header">
              {{ 'Objektzuordnung' | mrTranslate }}
            </div>
            <div class="card-block clr-row nxm clr-align-items-center">
              <cds-icon size="36" shape="file-settings" />
              <p class="card-text clr-col-lg clr-col-md-12 clr-col-sm">
                {{
                  "Bearbeiten, Erstellen und Löschen von Verknüpfungen 'Objekt-Maske' mit der Eingabe vom Intervall der Wartungen"
                    | mrTranslate
                }}
              </p>
            </div>
            <div class="card-footer">
              <button class="btn btn-sm btn-link">{{ 'Öffnen' | mrTranslate }}</button>
            </div>
          </a>
          <a (click)="openView.set('zähler')" class="card clickable subgrid subgrid-rows-only">
            <div class="card-header">
              {{ 'Zählerzuordnung' | mrTranslate }}
            </div>
            <div class="card-block clr-row nxm clr-align-items-center">
              <cds-icon size="36" shape="zaehler" />
              <p class="card-text clr-col-lg clr-col-md-12 clr-col-sm">
                {{
                  "Bearbeiten, Erstellen und Löschen von Verknüpfungen für die Maske 'Zählerprogramme'" | mrTranslate
                }}
              </p>
            </div>
            <div class="card-footer">
              <button class="btn btn-sm btn-link">{{ 'Öffnen' | mrTranslate }}</button>
            </div>
          </a>
          <!-- <a (click)="openView.set('pdfeinstellung')" class="card clickable subgrid subgrid-rows-only">
:              {{ "PDF-Einstellungen" | mrTranslate }}
            </div>
            <div class="card-block clr-row nxm clr-align-items-center">
              <cds-icon size="36" shape="zaehler"/>
              <p class="card-text clr-col-lg clr-col-md-12 clr-col-sm">
                {{ "Anpassen des Layouts für Wartungs-PDFs" | mrTranslate }}
              </p>
            </div>
            <div class="card-footer">
              <button class="btn btn-sm btn-link"> {{ "Öffnen" | mrTranslate }} </button>
            </div>
          </a> -->
        </div>
      </div>
    }
    @case ('baum') {
      <app-wartungsbaum [otypid]="otypid()" />
    }
    @case ('masken') {
      <app-wartungsmasken [otypid]="otypid()" [refresh]="dataRefresh" (view)="openView.set($event)" />
    }
    @case ('zuordnung') {
      <app-wartungsobjektzuordnung [otypid]="otypid()" [refresh]="dataRefresh" (view)="openView.set($event)" />
    }
    @case ('zähler') {
      <app-wartungszaehlerzuordnung [otypid]="otypid()" (view)="openView.set($event)" />
    }
    @case ('personal') {
      <div class="w-100-p padding-10-lr padding-12-b scroll-y h-60 clr-row nxm">
        <div class="clr-col-lg-8 clr-col-12 h-100 centred">
          <app-wartungsitem [mode]="'personal'" [otypid]="otypid()" [refresh]="dataRefresh" />
        </div>
      </div>
    }
    <!-- @case ('pdfeinstellung') {
      <app-wartungspdfeinstellung (view)="openView.set($event)"/>
    } -->
  }
</div>
